import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ExpedienteService } from '../expendiente.services';
import { Inject} from '@angular/core';
import * as colabInter from './../expediente.interface';
import * as backInter from 'app/auth/auth-data.model';
import { lang_wizard } from 'app/idiomas/i18n/expedientes35/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { fuseAnimations } from '@fuse/animations';
import {MatTableDataSource} from '@angular/material/table';
import { BehaviorSubject, Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { ColaboradoresEncuestadorService } from 'app/main/wizard-n35encuestador/services/colaboradoresEncuestador.service';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
export interface resuMedico{
  success: boolean,
  doctores: doctores[]
}
export interface doctores{
vivo: number,
_id: string,
nombre: string
cedula: string
especialidad: string
empresaId: string
domicilio: string
correo: string
nombreCT: string
id_CT: number
centroId: string
createdAt: string
updatedAt: string
}

export interface medicoData {
  success: boolean,
  doctores:{
    vivo: number,
    _id: string,
    nombre: string
    cedula: string
    especialidad: string
    empresaId: string
    domicilio: string
    correo: string
    nombreCT: string
    id_CT: number
    centroId: string
    createdAt: string
    updatedAt: string
  }
}

export interface DialogData {
  infoColaborador: any;
}

@Component({
  selector: 'tabla-medico',
  templateUrl: './tabla-medico.component.html',
  styleUrls: ['./tabla-medico.component.scss'],
  animations : fuseAnimations
})


export class TablaMedicoComponent implements OnInit {
  dataSource: MatTableDataSource<resuMedico>;
  productoCertificar: backInter.prodNorma35;
  productoCertificar_CT: backInter.prodNorma35;
  BtnTmp:boolean=true;
  @Input() actualizaMedicolist: Observable<any>;
  private eventsSubscription: any
  constructor(
    private expedienteService: ExpedienteService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private colaboradoresService: ColaboradoresEncuestadorService,
    private translateSrv: TranslateService,
    public dialog: MatDialog
  ) {
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }

  ngOnInit() {
    this.obtieneCertificarActual();
    //this.getMedicos();
    this.eventsSubscription = this.actualizaMedicolist.subscribe( (datos2) => {
      if(datos2){
        this.obtieneCertificarActual();
      }
    });

  }
  cargando:boolean=true;
  arrayDoctores:any;
  arrayFilter:any;
  nombresColumnasheader = ['name','workcenter','correo','telefono','clave','acciones'];
  nombresColumnasCont = ['name','workcenter','correo','telefono','clave','acciones'];
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  obtieneCertificarActual(){
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.productoCertificar_CT = producto;
              this.getMedicos(this.productoCertificar.idNorma35);
              console.log("Producto id");
              console.log(this.productoCertificar.idNorma35);
              throw BreakException;
            }
          }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };

    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }
  info:any;
  claves: any[] = [];
  arrayDoctorestmp:colabInter.resuMedico[]=[];
  statusDoctor:boolean = false;
  getMedicos(productoId){
    this.expedienteService.getDoctores(productoId).subscribe( (resu:colabInter.resuMedico) => {

      this.info=this.expedienteService.getInfoUsuario();
       let dataClave = {
        "productoId": this.productoCertificar.idNorma35,
        "empresaId": this.info.empresaId
      }
      this.expedienteService.getAllclave(dataClave).subscribe ( (resClave:any) =>{
        this.claves=resClave.claves;
        this.arrayDoctores=resu.doctores;
        if(this.arrayDoctores.length > 0){
          this.statusDoctor=true;
          this.cargando=false;
        }else{
          this.cargando=false;
        }
        this.dataSource = new MatTableDataSource(this.arrayDoctores);
        console.log("Claves doctores");
        console.log(resClave);
        this.dataSource.filterPredicate = (data, filterValue: string)  => {
          const accumulator = (currentTerm, key) => {
            return key === 'doctores' ? currentTerm : currentTerm + data[key];
          };
          const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
          // Transform the filterValue by converting it to lowercase and removing whitespace.
          const transformedFilter = filterValue.trim().toLowerCase();
          return dataStr.indexOf(transformedFilter) !== -1;
        };
        console.log("Información");
      });
    });
  }

  deleteDoc(idDoctor){

    let texto = 'WIZARD.ALERT.LABEL03';
    let rspSi = 'WIZARD.ALERT.BTN1';
    let rspNo = 'WIZARD.ALERT.BTN2';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        this.expedienteService.deleteDoctores(idDoctor).subscribe( (resu:any) => {
          this.getMedicos(this.productoCertificar.idNorma35);
        });

      }else{
        Swal.close();
      }
    });
  }
  rutaPagina:any;
  copyMessage(val: string){
    let textoResp= 'WIZARD.COPY';
    this.translateSrv.get(textoResp).subscribe((res: string) => { textoResp = res; });
    console.log("Translate "+textoResp);
    Swal.fire({
      icon: 'success',
      title: textoResp,

    });

    let texto = 'CIERRE.CIERRE.COPYLINK';
    // let url = DATOS_API.url.split(":");
    // this.rutaPagina = url[1] + "/surveyadministrator/counting/" + val;
    //this.rutaPagina = DATOS_API.urlConteos + val;
    //'home?empresa='+this.arrayDoctores[val].empresaId+'&medico='+this.arrayDoctores[val]._id+'&pod='+this.productoCertificar.idNorma35;
    this.rutaPagina='home?empresa='+this.arrayDoctores[val].empresaId+'&medico='+this.arrayDoctores[val]._id+'&pod='+this.productoCertificar.idNorma35+'&ct='+this.arrayDoctores[val].id_CT;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    // selBox.value=val;
    selBox.value=this.rutaPagina;
    console.log(this.rutaPagina);
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  AllDates_doc(idDoctor){
    this.expedienteService.getAlldoctordates(idDoctor).subscribe( (resu:any) => {
      console.log("Respuesta ");
      console.log(resu);
    });

  }
  openDialog(idCol?): void {
    let dataModal: any;


    //this.emitEventToChild2();
    const dialogRef = this.dialog.open(InfoCitaDialog, {
      width: '3500px', height: '600px',
      data: {infoColaborador: idCol}

    });
    dialogRef.afterClosed().subscribe(result => {
      // Actualizar doctores
      /*let dataIdarch = {
        seccionId: idSeccion,
        fechaDocumentador: this.fechaCertificar
      }
      if(idSeccion){
        this.actualizarTareas(dataIdarch);
      } */
    });

  }

}

@Component({
  selector: 'InfoCitaDialog',
  templateUrl: './citasdoc.dialog.component.html',
  styleUrls: ['./tabla-medico.component.scss'],
  animations : fuseAnimations
})


export class InfoCitaDialog {

  //private _unsubscribeAll: Subject<any>;
  Col_info:any;
  cargandoCitas:boolean=true;
  constructor(
    private colaboradoresService: ColaboradoresEncuestadorService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private expedienteService: ExpedienteService,
    public dialogRef: MatDialogRef<InfoCitaDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ){
    this.Col_info=data.infoColaborador;
    this.AllDates_doc(this.Col_info);

  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {

  }
  idiomaActual:string;
  arrayDoctorestmp:colabInter.citas[]=[];
  arrayCitas:any;
  statusDate:boolean=false;
  AllDates_doc(idDoctor){
    this.expedienteService.getAlldoctordates(idDoctor).subscribe( (resu:colabInter.resCitas) => {
      this.arrayCitas=resu.citas;
      setTimeout(function(){}, 5000);
      if(this.arrayCitas.length==0){
        this.statusDate=true;
        this.cargandoCitas=false;
      }else{
        this.cargandoCitas=false;
      }
      console.log(this.arrayCitas);
      for(let i=0; i<this.arrayCitas.length; i++){
        this.arrayCitas[i].fecha= this.arrayCitas[i].fecha.substr(0,10);
      }
      this.arrayCitas.filterPredicate = (data, filterValue: string)  => {
        const accumulator = (currentTerm, key) => {
          return key === 'citas' ? currentTerm : currentTerm + data[key];
        };
        const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
        // Transform the filterValue by converting it to lowercase and removing whitespace.
        const transformedFilter = filterValue.trim().toLowerCase();
        return dataStr.indexOf(transformedFilter) !== -1;
      };
    });

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.arrayCitas.filter = filterValue.trim().toLowerCase();
    console.log(this.arrayCitas);
  }






}
